var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStepperMinusGrayGyeongju({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x94\x8C\xEB\x9F\xAC\xEC\x8A\xA4",
    clipPath: "url(#clip0_1405_6328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 20H31.9999",
    stroke: "#E9EBEE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_6328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperMinusGrayGyeongju);
export default __webpack_public_path__ + "static/media/stepperMinusGrayGyeongju.25c36941.svg";
export { ForwardRef as ReactComponent };